import { DialogInOne } from '../../../../components';
import { useTranslation } from '../../../../hooks';
import ApproveRejectContent from '../ApproveRejectContent';
import { TransactionOperationTableRow } from '../ApproveRejectContent/types/TransactionOperationTable';

interface IProps {
  isOpen: boolean;
  closeDialog: () => void;
  title?: string;
  content?: React.ReactNode;
  selectedRow: TransactionOperationTableRow;
}

const ViewDialog = (props: IProps) => {
  const { title, isOpen, closeDialog, selectedRow } = props;
  const { tc } = useTranslation();

  const content = props.content || <ApproveRejectContent selectedRow={selectedRow} />;

  const dialogConfig = {
    title: title || tc('view'),
    self: {
      open: isOpen,
      onClose: () => {
        closeDialog();
      },
    },
    content: content,
    onConfirm: () => {},
    onCancel: () => {
      closeDialog();
    },
    isConfirmHidden: true,
    isFullScreen: true,
  };

  return <DialogInOne {...dialogConfig} />;
};

export default ViewDialog;
